import classNames from "classnames/bind";
import styles from "./SettingDefault.module.css";
import TableListConfig from "../TableListConfig";
import { Col, Row } from "antd";
import { Button, Empty, Loading, PlaySound, Toast } from "../../../components";
import { manageNotification } from "../../../services/api/manageNotification";
import { useEffect, useRef, useState } from "react";
import { columns } from "./configTableSettingDefault";
import { listIconLevel } from "../Setting/ConfigSpace/configTableConfigSpace";
import { useForm } from "antd/es/form/Form";
import Filter from "./Filter";

const cx = classNames.bind(styles);

function SettingDefault() {
    const [listType, setListType] = useState([]);
    const [listTypeAi, setListTypeAi] = useState([]);
    const [listTypeSystem, setListTypeSystem] = useState([]);
    const [valueConfig, setValueConfig] = useState([]);
    const [valueAiChange, setValueAiChange] = useState();
    const [valueSystemChange, setValueSystemChange] = useState();
    const refFormAI = useRef(null);
    const refFormSystem = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [colTable, setColTable] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [formFilter] = useForm();

    // Trả ra danh sách mức cảnh báo
    const getListNotificationLevel = async () => {
        try {
            const res = await manageNotification.getListNotificationLevel();
            if (res) {
                const listVal = res?.map(item => {
                    const level = listIconLevel?.find(lv => lv?.CODE === item?.CODE)
                    return {
                        label: <div className={cx('select-item')}>{level?.ICON || ""} {item?.DETAIL}</div>,
                        value: item?.CODE
                    }
                })
                return listVal;
            }
            return [];
        } catch (error) {
            throw error;
        }
    }
    // Lấy danh sách âm thanh
    const getListSound = async () => {
        try {
            const res = await manageNotification.getListNotificationSound()
            if (res) {
                const listSound = res?.map(item => {
                    return {
                        label: <div className={cx('select-item')}><p className={cx('name')}>{item?.NAME}</p> <PlaySound soundPath={""} /></div>,
                        value: item?.CODE
                    }
                })
                return listSound
            }
            return []
        } catch (error) {

        }
    }
    // Xử lý các cột cho bảng
    useEffect(() => {
        const getColTable = async () => {
            try {
                const listLevelNoti = await getListNotificationLevel();
                const listSound = await getListSound();
                const listCol = columns?.map((item) => {
                    if (item?.key === 'notification_level_code') {
                        return {
                            ...item,
                            options: listLevelNoti
                        }
                    }
                    if (item?.key === 'sound') {
                        return {
                            ...item,
                            options: listSound
                        }
                    }
                    return {
                        ...item
                    }
                })
                setColTable(listCol)
            } catch (error) {
                // console.log(error);
            }
        }
        getColTable()
    }, [columns])
    // Trả ra màu của tùng ai
    const getListColorRegister = async () => {
        try {
            const res = await manageNotification.getListService();
            return res ? res : [];
            // // console.log("res", res);
        } catch (error) {
            // console.log('eeeeee', error);
        }
    }
    // Trả ra giá trị của các cảnh báo của cam được chọn
    const getListCameraNotification = async () => {
        setLoading(true)
        try {
            const res = await manageNotification.getListCameraNotificationDefault();
            if (res) {
                setValueConfig(res);
            }
            // setLoading(false)
        } catch (error) {
            // setLoading(false)
            // console.log(error);
            Toast.open("Lấy thông tin cài đặt không thành công", "danger")
        }
    }
    // Trả ra danh sách các tên cảnh báo và add màu cảnh báo tương ứng với nó, hiện mới có AI chưa có system
    const getListNotifycationType = async () => {
        try {
            const res = await manageNotification.getListNotificationType();
            const listColorAi = await getListColorRegister();
            if (res) {
                const listNotificationTypeAddColor = res?.map((item) => {
                    const colorAI = listColorAi?.find(clAi => clAi?.NOTIFICATION_TYPE_CODE === item?.CODE)?.COLOR || "";
                    return {
                        ...item,
                        EVENT_COLOR: colorAI
                    }
                })
                setListType(listNotificationTypeAddColor);
            }
        } catch (error) {
            throw error;
        }
    }

    useEffect(() => {
        getListNotifycationType();
    }, [])
    // lấy theo camera code nhưng đang để lấy tạm lấy ra dữ liệu
    useEffect(() => {
        getListCameraNotification();
    }, [refresh])

    const handleSubType = (listTypeAddValue) => {
        const listNotificationTypeAI = listTypeAddValue?.filter(item => item?.ai_service_code !== null) || [];
        const listNotificationTypeSystem = listTypeAddValue?.filter(item => item?.ai_service_code === null) || [];
        setListTypeAi(listNotificationTypeAI);
        setListTypeSystem(listNotificationTypeSystem);
        setLoading(false);
    }

    // lấy ra mảng chứa đầy đủ thông tin cấu hình của từng loại cảnh báo theo giá trị của từng cam
    useEffect(() => {
        const listTypeAddValue = listType?.map(item => {
            const listConfigOfCode = valueConfig?.filter(val => val?.NOTIFICATION_TYPE_CODE === item?.CODE);
            let statusApp = 0;
            let statusTele = 0;
            listConfigOfCode.forEach(item => {
                if (item?.METHOD === "APP") {
                    statusApp = item?.STATUS;
                }
                if (item?.METHOD === "TELEGRAM") {
                    statusTele = item?.STATUS;
                }
            })
            const value = listConfigOfCode[listConfigOfCode?.length - 1];
            return {
                notification_level_code: value?.NOTIFICATION_LEVEL_CODE || "",
                telegram: statusTele === 1,
                app: statusApp === 1,
                alert_time: value?.ALERT_TIME || "",
                event_color: value?.COLOR || "",
                type_code: item?.CODE || "",
                detail: item?.DETAIL || "",
                ai_service_code: item?.AI_SERVICE_CODE,
                sound: value?.NOTIFICATION_SOUND_CODE
            }
        })
        handleSubType(listTypeAddValue);
    }, [listType, valueConfig])

    // Lấy thông tin từ form ai
    const handleChangeValueAi = (valConfig) => {
        setValueAiChange(valConfig?.configs)
    }
    // Lấy thông tin từ formsystem 
    const handleChangeValueSystem = (valueConfig) => {
        setValueSystemChange(valueConfig?.configs)
    }

    const hanldeSave = () => {
        if (refFormAI && refFormSystem) {
            refFormAI?.current?.submit();
            refFormSystem?.current?.submit();
        } else {
            Toast.open("Lỗi thông tin khi sửa", "danger")
        }
    }

    // Telegram và app mỗi kênh thông báo cần có một bản ghi, Tức là với một loại cảnh báo sẽ có một object cho app
    //  một object cho tele các thông tin khác giosnng nhau ở cả hai

    const saveConfig = async (configs) => {
        setModalLoading(true);
        try {
            const color = configs?.map(cf => {
                return {
                    color: cf?.event_color?.substring(1) || "",
                    notification_type_code: cf?.type_code
                }

            });
            const valueConfig = configs?.flatMap(cf => {
                const valConfig = {
                    alert_time: cf?.alert_time,
                    notification_type_code: cf?.type_code || "",
                    color: cf?.event_color?.substring(1) || "",
                    notification_level_code: cf?.notification_level_code || "",
                    sound_code: cf?.sound || ''
                }
                return [
                    {
                        ...valConfig,
                        method: "APP",
                        status: cf?.app ? 1 : 0
                    },
                    {
                        ...valConfig,
                        method: "TELEGRAM",
                        status: cf?.telegram ? 1 : 0
                    }
                ]
            });
            // const addDfColor = await manageNotification.postAddNotificationColorDefault({
            //     list_cam_noti: {
            //         data: color
            //     }
            // });
            await manageNotification.postAddNotificationValueDefault({
                company_code: formFilter.getFieldValue("company"),
                list_cam_noti: {
                    data: valueConfig
                }
            });
            Toast.open("Lưu cài đặt mặc định thành công", "success");
            setValueAiChange();
            setValueSystemChange();
            setModalLoading(false);
        } catch (error) {
            setModalLoading(false);
            Toast.open("Lưu cài đặt mặc định không thành công", "danger")
        }
    }

    useEffect(() => {
        if (valueAiChange && valueSystemChange) {
            const infoUpdate = [...valueAiChange, ...valueSystemChange];
            saveConfig(infoUpdate);
        }
    }, [valueAiChange, valueSystemChange])

    const handleRefresh = () => {
        setRefresh(!refresh)
    }
    return (
        <div className={cx('wrapper')}>
            {modalLoading && <div className={cx("modal-loading")}><Loading /></div>}
            <div className={cx("header")}>
                <h1 className={cx("title")}>Thiết lập mặc định</h1>
            </div>
            {loading ? <div className={cx("loading")}><Loading /></div> : (
                <>
                    <Filter form={formFilter} />
                    <div className={cx('config')}>
                        <TableListConfig
                            name={"Cảnh báo thông minh"}
                            dataSource={listTypeAi}
                            onChange={(valConfig) => handleChangeValueAi(valConfig)}
                            ref={refFormAI}
                            columns={colTable}
                        />
                    </div>
                    <div className={cx('config')}>
                        <TableListConfig
                            name={"Cảnh báo hệ thống"}
                            dataSource={listTypeSystem}
                            onChange={(valConfig) => handleChangeValueSystem(valConfig)}
                            ref={refFormSystem}
                            columns={colTable}
                        />
                    </div>
                    <Row gap={[0, 16]}>
                        <Col span={24}>
                            <div className={cx('footer')}>
                                <Button title={'Hủy bỏ'} className={cx('btn', 'cancel')} onClick={handleRefresh} />
                                <Button title={'Áp dụng tất cả'} className={cx('btn')} onClick={hanldeSave} />
                                <Button title={'Áp dụng mới'} className={cx('btn')} onClick={hanldeSave} />
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    )
}

export default SettingDefault;